import { Language } from '../../../enums/const-enums';

export interface RassChangeAccountTranslations {
  change_account_button: string;
}

const nlTranslations = {
  change_account_button: 'Wijzig rekening',
};

const enTranslations = {
  change_account_button: 'Change Account',
};

export const rassChangeAccountTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
